/**
 * Live TTS output level (0..1) for SAM's voice.
 *
 * Written by the onboarding audio player's analyser loop (see
 * `useOnboardingVoice.ts`) and read by `RobotAvatar` to drive the speaking
 * pulse. A plain module singleton — NOT Redux — so the ~60fps updates never
 * trigger React re-renders; the avatar reads it imperatively via
 * requestAnimationFrame. Only one voice session is ever active at a time, so a
 * single global level is sufficient.
 */
let level = 0

export const voiceAmplitude = {
  /** Publish the current level (clamped to 0..1; non-finite → 0). */
  set(v: number): void {
    level = Number.isFinite(v) ? Math.min(1, Math.max(0, v)) : 0
  },
  /** Read the current level. Safe to pass as a bare reference (no `this`). */
  get(): number {
    return level
  },
  reset(): void {
    level = 0
  },
}
